export default __webpack_public_path__ + "static/media/Boots of the Usurper.9f51227f.jpg";